import { FC } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { ITopBannerData } from '@pro/linearTopLight/interface';
import { ProdOverlayBanner } from '@app/linearTopLight/ProdOverlayBanner';
import { HtmlRender } from '@base/snippets/HtmlRender';
import { Link } from '@base/lib/Link';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import { useRouter } from 'next/router';

type ITopBannerProps = {
    data: ITopBannerData;
};

export const TopBanner: FC<ITopBannerProps> = ({ data }) => {
    const { pathname } = useRouter();
    return (
        <ProdOverlayBanner data={data} className={styles['top-banner']}>
            <div className={styles['top-banner-top']}>
                <HtmlRender className={styles.title} html={data.title}/>
                <div className={cn(styles.subtitle, 'g-font-ext-light')}>{data.subtitle}</div>
                <Link
                    className={cn(styles['btn-quote'], 'g-font-ext-light')}
                    href={generatePath(RouteEnum.CONTACT, { from: `${pathname} GET A QUOTE` })}
                >
                    {data.contactLinkText}
                </Link>
            </div>

            <HtmlRender className={styles.desc} html={data.description}/>
        </ProdOverlayBanner>
    )
};
